import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {EStorageKeys} from 'src/constants';
import {listenerMiddleware} from 'src/models';

import {TFilters} from './definitions';

const initialState = () => {
  const rememberedFilters = sessionStorage.getItem(EStorageKeys.BROADCASTS_FILTERS);

  return {
    filters: rememberedFilters ? JSON.parse(rememberedFilters) : {},
  };
};

const broadcastsSlice = createSlice({
  name: 'broadcasts',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<TFilters>) {
      state.filters = action.payload;
    },
  },
});

export const {setFilters: setFiltersAction} = broadcastsSlice.actions;
export const selectFilters = (state: TRootState) => state.broadcasts.filters as TFilters;

listenerMiddleware.startListening({
  actionCreator: setFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(EStorageKeys.BROADCASTS_FILTERS, JSON.stringify(action.payload));
  },
});

export default broadcastsSlice.reducer;
